import { render, staticRenderFns } from "./BIPeriodSelect.vue?vue&type=template&id=dd1c7a82&scoped=true"
import script from "./BIPeriodSelect.vue?vue&type=script&lang=js"
export * from "./BIPeriodSelect.vue?vue&type=script&lang=js"
import style0 from "./BIPeriodSelect.vue?vue&type=style&index=0&id=dd1c7a82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c7a82",
  null
  
)

export default component.exports